import { ORDER_STATUS } from "../../Shared/utils/constants";
const validStatusesForPriceUpdate = [ORDER_STATUS.PENDING, ORDER_STATUS.ACTIVE, ORDER_STATUS.FUTURE];
export const getShouldShowPriceUpdates = (selectedOrder) => {
    if (!selectedOrder || !(selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.OrderStatus)) {
        return false;
    }
    return validStatusesForPriceUpdate.includes(selectedOrder.OrderStatus);
};
